//booking widget variables
var start = document.getElementById('arriveInput').value;
var end = document.getElementById('departureInput').value;
var opened = 0;
var opencheck;



// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

	
		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

	

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

	
	
		//Booking open close
		if(document.querySelector('.btn-booking')){
			document.querySelector('.btn-booking').addEventListener('click' , (e)=>{
				e.preventDefault();
				document.querySelector('.booking-block').classList.toggle('open');
			})
		}

		if( document.querySelector('.js-booking-close') ){
			document.querySelector('.js-booking-close').addEventListener('click' , ()=>{
				document.querySelector('.booking-block').classList.remove('open');
			})
		}

		//animation ended primary

		if( document.getElementById('js-btn-menu') ){
			document.getElementById('js-btn-menu').addEventListener('click', (elm)=>{
				document.querySelector('.container-menu-mobile').classList.toggle('open')
			})
		}

		if( document.querySelector('.close-menu') ){
			document.querySelector('.close-menu').addEventListener('click', (elm)=>{
				document.querySelector('.container-menu-mobile').classList.remove('open')
			})
		}

			
	let allmainNav = document.getElementById('primary-nav').getElementsByTagName('a');
	let allmainLength = allmainNav.length;
	for(let i = 0; i < allmainLength; i++){
		allmainNav[i].addEventListener('click', function(e){
			if( window.screen.width <= 1024 ){

				if(this.nextElementSibling !== null){
					e.preventDefault();
					
					if(! this.nextElementSibling.classList.contains('open-item')){
						this.nextElementSibling.classList.add('open-item');
					} else {
						this.nextElementSibling.classList.remove('open-item');
					}
				}

			}
		})
	}



		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};
	

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}


		if(document.getElementById('default') || document.getElementById('gallery') || document.getElementById('attractions') ){
			document.getElementById('header').classList.add('default');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}



/** BOOKING WIDGET FUNCTIONALITY */
(function(){

	$(document).ready(function () {
		//To create after event 
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function (inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		}
		$('#arriveInput').on('change', function(){
			start = $(this).val();
			$('.calendar-block').datepicker("setDate", start)
		})
		$('#departureInput').on('change', function(){
			end = $(this).val();
			$('.calendar-block').datepicker("setDate", end)
		})

		$('.calendar-block').datepicker({
			changeMonth: false,
			dateFormat: 'mm-dd-yy',
			numberOfMonths: 1,
			beforeShowDay: function (date) {
				setTimeout(function() {
					document.querySelectorAll('.ui-datepicker-calendar td a').forEach(e => {
					e.setAttribute('tabindex', '-1');
					})
				},1000);

				$.datepicker._defaults.dateFormat = "mm-dd-yy";
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date; 
					opencheck = 0;
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}
				
					
				}
				//console.log(start);
				//console.log(end);

				$('#arriveInput').attr('value', start);
				$('#departureInput').attr('value', end);

				alternativeDates(start, end);
			
			},
			onChangeMonthYear: function () {
				opencheck = 1;
			}
		});
	});

	function alternativeDates(start, end) { 
		let checkin = start.split("-");
		let checkout = end.split("-");
		$("#arriveInputAlt").val(checkin[2]+'-'+checkin[0]+'-'+checkin[1]);
		$("#departureInputAlt").val(checkout[2]+'-'+checkout[0]+'-'+checkout[1]);
	}


}());